<template>
  <div class="editPreInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回上一级</el-button>
      </div>
      <el-form v-if="Object.keys(ruleForm).length>0" :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws13" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item label="开关门检测使能" prop="MsgBody.DoorDetectEnable">
          <el-select v-model="ruleForm.MsgBody.DoorDetectEnable">
            <el-option label="不检测" :value='0'></el-option>
            <el-option label="检测" :value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="迎宾楼层" prop="MsgBody.VisitorFLoor">
          <el-input v-model="ruleForm.MsgBody.VisitorFLoor" class="item-input"
            placeholder="请输入迎宾楼层（使用英文的','分隔，例：1,2,3,4,5）"></el-input>
          <el-tooltip style="margin-left: 10px;" effect="light" placement="top">
            <div slot="content">
              <span style="font-size:14px">请输入迎宾楼层（使用英文的','分隔，例：1,2,3,4,5）</span>
            </div>
            <i class="el-icon-warning xjbzTips"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="开门的最长时间（s）" prop="MsgBody.MaxDoorOpenTime">
          <el-input v-model.number="ruleForm.MsgBody.MaxDoorOpenTime" class="item-input" placeholder="请输入开门的最长时间">
          </el-input>
          <el-tooltip style="margin-left: 10px;" effect="light" placement="top">
            <div slot="content">
              <span style="font-size:14px">楼层正常开门保持最长时间，单位 s</span>
            </div>
            <i class="el-icon-warning xjbzTips"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="频繁开关门次数报警" prop="MsgBody.MaxDoorOpenFreq">
          <el-input v-model.number="ruleForm.MsgBody.MaxDoorOpenFreq" class="item-input" placeholder="请输入频繁开关门次数报警">
          </el-input>
          <el-tooltip style="margin-left: 10px;" effect="light" placement="top">
            <div slot="content">
              <span style="font-size:14px">45秒内开关门次数</span>
            </div>
            <i class="el-icon-warning xjbzTips"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="平层困人(不开门)报警延时（s）" prop="MsgBody.LvlAlarmPeopleTime">
          <el-input v-model.number="ruleForm.MsgBody.LvlAlarmPeopleTime" class="item-input"
            placeholder="请输入平层困人(不开门)报警延时（s）"></el-input>
        </el-form-item>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save()">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      var numReg = (rule, value, callback) => {
        const reg = /^\d+$/
        // 当数据为空时，不进行校验
        if (!value) {
          return callback()
        }
        setTimeout(() => {
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正整数'))
          }
        }, 100)
      }
      return {
        isDisabled: false,
        parentData: {},
        regcode: '',
        ruleForm: {},
        rules: {
          'MsgBody.DoorDetectEnable': [{
            required: true,
            message: '请选择开关门检测使能',
            trigger: 'change'
          }],
          'MsgBody.MaxDoorOpenTime': [{
            required: true,
            validator: numReg,
            message: '请输入开门的最长时间',
            trigger: 'blur'
          }],
          'MsgBody.MaxDoorOpenFreq': [{
            required: true,
            validator: numReg,
            message: '请输入频繁开关门次数报警',
            trigger: 'blur'
          }],
          'MsgBody.LvlAlarmPeopleTime': [{
            required: true,
            validator: numReg,
            message: '请输入平层困人(不开门)报警延时',
            trigger: 'blur'
          }],
        },
      }
    },
    created() {
      this.parentData = this.$route.query.object
      this.regcode = this.$route.query.object.Registercode
      this.getDoorRead()
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // form数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      // 返回
      back() {
        console.log(this.parentData)
        this.$router.push({
          name: 'elevatorDetail',
          query: {
            object: this.parentData
          }
        })
      },
      // 获取设备参数
      getDoorRead() {
        let loading = this.$loading()
        this.$postJson(`aapi/getDoorDetectList`, {
          'token': 'zlj365',
          'regcode': this.regcode
        }).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              if (res.liftInfo) {
                this.ruleForm = res.liftInfo
                this.ruleForm.MsgBody.VisitorFLoor = this.ruleForm.MsgBody.VisitorFLoor.join(',')
                this.saveData = JSON.stringify(res.liftInfo)
                this.isDisabled = true
              } else {
                this.$message.error('获取设备信息失败')
                this.back()
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      save() {
        console.log(this.ruleForm.MsgBody)
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            let loading = this.$loading()
            this.$postJson(`aapi/setDoorDetect`, {
              'token': 'zlj365',
              'regcode': this.regcode,
              'DoorDetectEnable': this.ruleForm.MsgBody.DoorDetectEnable,
              'MaxDoorOpenTime': this.ruleForm.MsgBody.MaxDoorOpenTime,
              'MaxDoorOpenFreq': this.ruleForm.MsgBody.MaxDoorOpenFreq,
              'LvlAlarmPeopleTime': this.ruleForm.MsgBody.LvlAlarmPeopleTime,
              'VisitorFLoor': this.ruleForm.MsgBody.VisitorFLoor,
            }).then(
              res => {
                loading.close()
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success('保存成功')
                  this.back()
                } else {
                  this.$message.error(res.errMsg)
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          }
        })
      }
    },
  }
</script>

<style lang="scss">
  .editPreInfo {
    .item-input {
      width: 30%;
    }
  }
</style>